var Vue = require('vue');
var $ = require('js/sw-jquery/sw-jquery');
var axios = require('axios');
var VueAxios = require('vue-axios');
var sw  = require('js/lib/sw');
var _ = require('underscore');
var confirmTemplate = require('rrViewComponents/Inshape/AccessControl/AccessControlManageRolesComponent/confirm-dialog.mustache');

Vue.use(VueAxios,axios);

var DISABLED_CLASSES = 'sw--is-no-pointer-events btn--disabled';
var CONFIRMED_DIALOG = false;


var mountedFragment = function mountedFragment() {
  this.$nextTick(function () {
    var _this = this;
    var $el = $(this.$el);
    sw.trigger('sw-fragment-loaded', $el);
    // Listen to changes in the selectric dropdown and pass it to the the Vue object method
    $el.on('selectric-change', function(e, el) {
      _this.dispatchInputEvent(el.value, el.text);
    });
  });
};

$(document).ready(function() {
  $('body').on('click', '[data-sw-noty-confirm-btn]', function() {
    CONFIRMED_DIALOG = true;
  });
});


module.exports = function ($fragment) {
  $fragment.swFindWithSelf("[data-sw-manage-roles]").each(function () {

    new Vue({
      el: this,
      data: {
        departmentId: 0,
        departmentName: '',
        roles: sw.data.roles,
        selectedRoles: [],
        editRoleEnabled: 0,
        newRoleName: ''
      },
      mounted: mountedFragment,
      computed: {
        filteredRoles: function() {
          var self = this;
          return this.roles.filter(function(el) {
            return el.role_category_id == self.departmentId;
          });
        },
        isDisabled: function() {
          if(this.selectedRoles.length <= 0) {
            return DISABLED_CLASSES;
          }
          return false;
        },
        canAddRole: function() {
          return this.departmentId == 0 ? false : true;
        }
      },
      methods: {
        dispatchInputEvent: function dispatchInputEvent(value, text) {
          this.departmentId = value;
          this.departmentName = text;
        },
        editRoleName: function(roleId) {
          this.editRoleEnabled = roleId;
        },
        canEditRole: function(roleId) {
          return roleId == this.editRoleEnabled ? false : true;
        },
        disableRoleEdit: function() {
          return this.editRoleEnabled = 0;
        },
        addNewRole: function() {
          var self = this;
          var bodyData = new FormData();
          bodyData.set('roleName', self.newRoleName);
          bodyData.set('departmentId', self.departmentId);
          var requestHeaders = {
            headers: {'Content-Type': 'multipart/form-data'}
          };
          this.$http.post('/access-control/roles/addRole',bodyData,requestHeaders)
            .then(function (response){
              var newRoleId = response.data.roleId;
              self.roles.push({
                'role_category_id' : self.departmentId,
                'role_category_name': self.departmentName,
                'role_id' : newRoleId,
                'role_name' : self.newRoleName
              });
              //clear input field
              self.newRoleName = '';
            }).catch(function(error){
            sw.notifications.error(error);
          });
        },
        deleteRoles: function() {
          var self = this;
          var selectedRoles = this.selectedRoles.toString();
          sw.notifications.full('Are you sure you want to delete all roles selected?',{
            layout: 'center',
            template: confirmTemplate,
            callback: {
              afterClose: function() {
                if(CONFIRMED_DIALOG) {
                  self.$http.get('/access-control/roles/delete?roleIds=' + selectedRoles)
                    .then(function() {
                      self.roles = _.filter(self.roles,function(role) { return !_.contains(self.selectedRoles, role.role_id);});
                    }).catch(function(error){
                    sw.notifications.error(error);
                  });
                  CONFIRMED_DIALOG = false;
                }
              }
            }
          });
        },
        deleteRole: function(roleId, roleName) {
          var self = this;
          sw.notifications.full('Are you sure you want to delete ' + roleName + '?',{
            layout: 'center',
            template: confirmTemplate,
            callback: {
              afterClose: function() {
                if(CONFIRMED_DIALOG) {
                  self.$http.get('/access-control/roles/delete?roleIds=' + roleId)
                    .then(function() {
                      self.roles = _.filter(self.roles,function(role) { return role.role_id != roleId});
                    }).catch(function(error){
                      sw.notifications.error(error);
                  });
                  CONFIRMED_DIALOG = false;
                }
              }
            }
          })
        }
      }
    });
  });
};
